export const VALUES = {
  bodyLoadingSkeletonCount: 6,
  localStorageKeys: {issueNewBody: (prefix: string, issueId: string) => `${prefix}-i${issueId}.view-issue-body-edit`},
  ghost: {
    login: 'ghost',
    name: undefined,
    avatarUrl: '/ghost.png',
    profileUrl: '/ghost',
  },
}
